import React, {useState}      from 'react';
import classnames             from 'classnames';
import { FontAwesomeIcon }    from '@fortawesome/react-fontawesome';

import PartImage              from './PartImage';
import PartDatasheet          from './PartDatasheet';
import PartInfo               from './PartInfo';

import IconQuantityComplete   from 'images/bom/stock.png'

const SubstituteEmptyVendorBlock = (props) => {
  return(
    <React.Fragment>
      <td className="vendor">
        <div> Not opcion for this part. </div>
      </td>
      <td className="stock"></td>
      <td className="order-qty"></td>
      <td className="price"></td>
      <td className="action"></td>
    </React.Fragment>
  )
}

const SubstituteVendorBlock = (props) => {
  const [qty, setQty] = useState(0);
  return(
    <React.Fragment>
      <td className="vendor">
        <div className="vendor">{props.option.vendor}</div>
        <div className="vpn">
          {props.option.vpn}
          {(props.option.packaging_shortcut)
            ? <span className="badge packaging">{props.option.packaging_shortcut}</span>
            : null
          }
        </div>
      </td>
      <td className="stock">
        {props.option.stock}
      </td>
      <td className="order-qty">
        <input type="text" 
         className="form-control form-control-sm"
         onChange={e => setQty(e.target.value)} />
      </td>
      <td className="price text-end">
        ${numeral((props.option.unit_price * qty)).format('0.00')}
      </td>
      <td className="action text-center">
        <input type="checkbox" 
         value="1"
         onChange={e => props.onHandleChangeQuantity(e.target.checked,
                                                     qty,
                                                     props.substitute.id,
                                                     props.option.id, 
                                                     props.option.unit_price,
                                                     props.substitute,
                                                     props.offer_id,
                                                     props.type,
                                                     props.selected_quantity,
                                                     props.onSelectSubstitutePart)}/>

      </td>
    </React.Fragment>
  )
}

const SubstitutePartTableHead = (props) => {
  return (
    <thead>
      <tr>
        <th className="image"></th>
        <th className="datasheet"></th>
        <th className="mpn">Manufacturer Part Number</th>
        <th className="vendor">Vendor</th>
        <th className="stock">Stock</th>
        <th className="required-qty">Qty</th>
        <th className="price">Price</th>
        <th className="action"></th>
      </tr>
    </thead>
  )
}

const SubstitutePartRow = (props) => {
  var vendor_options = props.substitute.vendor_options;
  var rowspan = vendor_options.length || 1;
   
  var options = []

  if (vendor_options.length == 0) {
    options.push(
      <SubstituteEmptyVendorBlock />
    )
  }

  vendor_options.forEach(function (option, index) {
    options.push(
      <SubstituteVendorBlock 
       offer_id={props.offer_id}
       option={option}
       substitute={props.substitute}
       qty_per_board={props.qty_per_board}
       selected_quantity={props.selected_quantity} 
       onSelectSubstitutePart={props.onSelectSubstitutePart} 
       onHandleChangeQuantity={props.onHandleChangeQuantity} 
       type="substitute" />
    )
  });

  var first_option = options[0];
  var options_length = options.length;
  if (options.length > 1) {
    options.shift()
  }
  return(
    <React.Fragment>
      <tr key={props.substitute.id}>
        <td className="image"
          rowSpan={rowspan}>
          <PartImage 
           images={props.substitute.image} />
        </td>
        <td className="datasheet"
         rowSpan={rowspan}>
          <PartDatasheet 
           urls={props.substitute.datasheet} />
        </td>
        <td className="mpn"
         rowSpan={rowspan}>
          <PartInfo 
           mpn={props.substitute.mpn}
           manufacturer={props.substitute.manufacturer}
           reference_designator={props.substitute.reference_designator} />
          <div className="description">
            {props.substitute.description}
          </div>
        </td>
        {first_option}
      </tr>
      {(options_length > 1)
        ? options.map((option) => (
            <tr>
              {option}
            </tr>
          ))
        : null
      } 
    </React.Fragment>
  )
}

const SubstitutePartTableBody = (props) => {
  return (
    <tbody>
      {props.substitutes.map((substitute) => (
        <SubstitutePartRow
          key={"substitute-part-" + props.offer_id + "-" + substitute.id}
          offer_id={props.offer_id}
          substitute= {substitute}
          substitute_id = {substitute.id} 
          qty_per_board={props.qty_per_board}
          selected_quantity={props.selected_quantity} 
          onSelectSubstitutePart={props.onSelectSubstitutePart} 
          onHandleChangeQuantity={props.onHandleChangeQuantity} />
      ))}
    </tbody>
  )
}

const SubstitutePartTableFooter = (props) => {
  let isOk = false;
  if (props.quantity_selected >= props.needed_quantity){
    isOk = true;
  }
  return(
    <tfoot>
      <tr>
        <td colSpan="5"></td>
        <td className="total-qty-selected">
          <div className="title">
            QUANTITY<br/>
            SELECTED:
          </div>
          <div className="value">
            {props.quantity_selected}
            {(isOk)
              ? <img className="qty-ok icon-bom-admin" 
                 src={IconQuantityComplete} 
                 alt="Quantity is complete" /> 
              : null
            }
          </div>
        </td>
        <td className="total-price">
          <div className="title">
            TOTAL<br/>
            PRICE:
          </div>
          <div className="value text-end">
            ${numeral((props.total_price)).format('0.00')}
          </div>
        </td>
        <td>
        </td>
      </tr>
    </tfoot>
  )
}
 
const SubstitutePartTable = (props) => {

  const [options, setOptions] = useState([])
  const [quantity_selected, setQuantitySelected] = useState(0)
  const [total_price, setTotalPrice] = useState(0.00)

  // const setQuantities = e => {
  //   setState({
  //     ...quantities,
  //     [e.target.name]: e.target.value
  //   });
  // };


  const handleChangeQuantity = (is_checked, qty, substitute_id, option_id, unit_price, substitute, offer_id, type, selected_quantity, onSelectSubstitutePart) => {
    if (is_checked){
      // Add to list
      setOptions(options.concat([substitute_id + "," + option_id]));
      setTotalPrice(total_price + (unit_price * qty));
      setQuantitySelected(quantity_selected + parseInt(qty));
    }else{
      var new_options = options; // make a separate copy of the array
      var index = new_options.indexOf(substitute_id + "," + option_id);
      if (index !== -1) {
        new_options.splice(index, 1);
        setOptions(new_options);
      }
      setTotalPrice(total_price - (unit_price * qty));
      setQuantitySelected(quantity_selected - parseInt(qty));
    }

    onSelectSubstitutePart(is_checked,
                             offer_id, 
                             substitute_id,
                             substitute,
                             selected_quantity,
                             type,
                             option_id,
                             qty );
  }
  
  let qty_per_board = props.offer.qty_per_board || 1;
  let substitutes = props.substitutes;
  
  if (substitutes.length === 0){
    return null
  }else{
    return(
      <div className="search-table">
        <table className="table table-responsive">
          <SubstitutePartTableHead />
          <SubstitutePartTableBody 
           offer_id={props.offer_id}
           substitutes={substitutes} 
           qty_per_board={qty_per_board}
           selected_quantity={props.selected_quantity} 
           onSelectSubstitutePart={props.onSelectSubstitutePart}
           onHandleChangeQuantity={handleChangeQuantity} />
          <SubstitutePartTableFooter 
            needed_quantity={props.needed_quantity}
            quantity_selected={quantity_selected}
            total_price={total_price}/>
        </table>
      </div>
    )
  }
};

export default SubstitutePartTable;
